import { render, staticRenderFns } from "./hr-login.vue?vue&type=template&id=b3140e50&scoped=true"
import script from "./hr-login.vue?vue&type=script&lang=ts"
export * from "./hr-login.vue?vue&type=script&lang=ts"
import style0 from "./hr-login.vue?vue&type=style&index=0&id=b3140e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3140e50",
  null
  
)

export default component.exports